var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.key})],1),(!_vm.$route.meta.hideFooter)?_c('Foot'):_vm._e(),(!_vm.$route.meta.hideFooter)?_c('NavBar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }